<div class="inbox-error">
    <div class="inbox-error__box" *ngIf="errorType === SMART_INBOX_STATE.CONNECTION_ERROR">
        <h3>{{ 'smart_inbox.error_on_call.connection_error.title' | translate }}</h3>
        <p>{{ 'smart_inbox.error_on_call.connection_error.description' | translate }}</p>
        <ui-button [label]="'smart_inbox.error_on_call.connection_error.go_back' | translate" type="primary" (click)="action()"></ui-button>
    </div>
    <div class="inbox-error__box" *ngIf="errorType === SMART_INBOX_STATE.SERVICE_ERROR">
        <h3>{{ 'smart_inbox.error_on_call.service_error.title' | translate }}</h3>
        <p>{{ 'smart_inbox.error_on_call.service_error.description' | translate }}</p>
        <ui-button [label]="'smart_inbox.error_on_call.service_error.refresh' | translate" type="primary" (click)="refresh()"></ui-button>
    </div>
</div>
